// Feature gating — checks user plan from localStorage
// Free plan (email signup) = daily brief access
// Pro = weekly, monthly, and all premium features

export const getUser = () => {
  try {
    const u = localStorage.getItem('knowfi_user');
    return u ? JSON.parse(u) : null;
  } catch { return null; }
};

export const isPro = () => {
  const u = getUser();
  return u?.plan === 'pro';
};

// User is on email list (signed up for daily brief)
export const isSubscribed = () => {
  if (localStorage.getItem('knowfi_subscribed') === 'true') return true;
  const u = getUser();
  return !!(u?.email || u?.subscribed);
};

// Mark user as subscribed to email list
export const markSubscribed = (email) => {
  localStorage.setItem('knowfi_subscribed', 'true');
  if (email) localStorage.setItem('knowfi_subscriber_email', email);
};

// AI question counter (free: 3/day, Pro: 50/day)
const AI_LIMIT_FREE = 3;
const AI_LIMIT_PRO  = 50;
const AI_KEY      = 'knowfi_ai_count';
const AI_DATE_KEY = 'knowfi_ai_date';

const getAILimit = () => isPro() ? AI_LIMIT_PRO : AI_LIMIT_FREE;

const resetIfNewDay = () => {
  const today = new Date().toDateString();
  if (localStorage.getItem(AI_DATE_KEY) !== today) {
    localStorage.setItem(AI_DATE_KEY, today);
    localStorage.setItem(AI_KEY, '0');
  }
};

export const canAskAI = () => {
  resetIfNewDay();
  const count = parseInt(localStorage.getItem(AI_KEY) || '0');
  return count < getAILimit();
};

export const getRemainingAI = () => {
  resetIfNewDay();
  const count = parseInt(localStorage.getItem(AI_KEY) || '0');
  return Math.max(0, getAILimit() - count);
};

export const incrementAICount = () => {
  resetIfNewDay();
  const count = parseInt(localStorage.getItem(AI_KEY) || '0');
  localStorage.setItem(AI_KEY, String(count + 1));
};

// Game Plan counter (free: 1 per day, Pro: 10 per day)
const GP_KEY = 'knowfi_gp_count';
const GP_DATE_KEY = 'knowfi_gp_date';

export const canGeneratePlan = () => {
  if (isPro()) return true;
  const today = new Date().toDateString();
  if (localStorage.getItem(GP_DATE_KEY) !== today) return true;
  return parseInt(localStorage.getItem(GP_KEY) || '0') < 1;
};

export const incrementPlanCount = () => {
  const today = new Date().toDateString();
  localStorage.setItem(GP_DATE_KEY, today);
  localStorage.setItem(GP_KEY, '1');
};

// Feature access rules
export const FEATURES = {
  marketFull: isPro,
  marketHistory: isPro,
  newsAll: isPro,
  courseFull: isPro,
  courseAI: isPro,
  calcAdvanced: isPro,
  ratesFull: isPro,
  aiPro: isPro,
};
